module.exports = __webpack_public_path__ + "img/cms_client_data_publish.77472243.png";